"use client"

import type React from "react"
import { StyleSheet, View } from "react-native"
import { useTheme } from "../contexts/ThemeContext"
import { LinearGradient } from "expo-linear-gradient"

interface GradientBackgroundProps {
  children: React.ReactNode
}

export function GradientBackground({ children }: GradientBackgroundProps) {
  const { isDarkMode } = useTheme()

  return (
    <View style={styles.container}>
      <LinearGradient colors={isDarkMode ? ["#1a1a2e", "#16213e"] : ["#e0f2fe", "#bfdbfe"]} style={styles.gradient}>
        {children}
      </LinearGradient>
    </View>
  )
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  gradient: {
    flex: 1,
    width: "100%",
  },
})

